import { OnboardingRequestDetailModel } from '@uag/welcome-shared/src/api/models';
import { useTranslation } from 'react-i18next';

import existingCustomerImage from '../assets/existingCustomerRequest.svg';

type Props = {
    request: OnboardingRequestDetailModel;
};
export const ExistingCustomerRequest = ({ request }: Props) => {
    const { t } = useTranslation();
    if (request.currentState !== 'DataVerification') {
        return;
    }
    const customerNumber = request.companyData.customerIdentifier;
    return (
        customerNumber && (
            <div className="gap-3xl border-border-light bg-background-gray-ultra-ultra-light flex rounded-md border border-solid">
                <div className="gap-base p-2xl flex basis-3/4 flex-col">
                    <div className="text-base">{t('existingCustomerRequest')}</div>
                    <div className="text-text-light text-base">
                        {t('customerrequestDescription', {
                            number: customerNumber,
                        })}
                    </div>
                </div>
                <div className="pr-xl">
                    <img className="h-full w-full" src={existingCustomerImage} />
                </div>
            </div>
        )
    );
};
